// C-Quote API
import {
    RequestConfigFunction,
} from 'app/types/request.types'

type CQuoteRequests = {
    domainName: string,
    getCQuoteFeesData: RequestConfigFunction<Record<string, any> | undefined>,
    create: RequestConfigFunction<Record<string, any> | undefined>,
    getCQuoteQuotationDetails: RequestConfigFunction<Record<string, any> | undefined>,
    cQuotesFilterRequest: RequestConfigFunction<Record<string, any> | undefined>,
    getCQuote: RequestConfigFunction<{ id: number }>,
    getCQuoteDocuments: RequestConfigFunction<{ id: number }>,
    generateDocument: RequestConfigFunction<Record<string, any> | undefined>,
}

const cQuoteRequests: CQuoteRequests = {
    domainName: 'CQuote',
    getCQuoteFeesData: (params) => {
        return {
            url: 'cquote/fees-data',
            data: {
                ...params,
            },
            method: 'POST',
        }
    },
    create: (params = {}) => {
        return {
            url: 'cquote/generate',
            data: {
                ...params,
            },
            method: 'POST',
        }
    },
    generateDocument: (params = {}) => {
        return {
            url: 'cquote/quotedocument/generation',
            data: {
                ...params,
            },
            method: 'POST',
        }
    },
    getCQuoteQuotationDetails: (params = {}) => {
        return {
            url: 'cquote/quotation-details',
            data: {
                ...params,
            },
            method: 'POST',
        }
    },
    cQuotesFilterRequest: (params = {}) => {
        return {
            url: 'cquote/filter-request/all',
            method: 'POST',
            ...params?.params,
            data: {
                ...params?.data,
            },
        }
    },
    getCQuote: ({
        id,
    }) => {
        return {
            url: `cquote/${id}`,
            method: 'GET',
        }
    },
    getCQuoteDocuments: ({
        id,
    }) => {
        return {
            url: `cquote/${id}/cquotedocument/filter-request/all`,
            method: 'POST',
        }
    },
}

export default cQuoteRequests
